'use strict';

var React = require('react');

var SvgLandingPageMajor = function SvgLandingPageMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 7c0-.552-.449-1-1-1h-9a1 1 0 0 1 0-2h9c1.654 0 3 1.346 3 3v5.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a.998.998 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414l1.293 1.293v-5.586zm8.56-2.853a1.5 1.5 0 0 1 .44 1.06v13.293a1.5 1.5 0 0 1-1.5 1.5h-13a1.5 1.5 0 0 1-1.5-1.5v-10.5h2v10h12v-12.586l-3.414-3.414h-10.586v-.5a1.5 1.5 0 0 1 1.5-1.5h9.293a1.5 1.5 0 0 1 1.06.44l3.708 3.707z"
  }));
};

exports.SvgLandingPageMajor = SvgLandingPageMajor;
